import React from 'react';
import { useTranslation } from 'react-i18next';

import { useStyles } from './Permissions.styles';
import theme from '../../../styles/theme';
import FlexibleColumnsTable from '../../../components/reusable/Table/FlexibleColumnsTable';
import { useAclComponent } from './useAclComponent';
import ConfirmDialog from '../../../components/reusable/confirm-dialog/ConfirmDialog';
import Search from '../../../components/reusable/search/Search';
import AppDialog from '../../../components/reusable/app-dialog/AppDialog';
import AddPermission from './add-permission/AddPermission';
import { Box } from '@mui/material';
import AppButton from '../../../components/designe/app-button/AppButton';
import { useAccess } from '../../../hooks/useAccess';

const Permissions = (props) => {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    sortedArray,
    columnsList,
    order,
    orderBy,
    cellReducers,
    onSort,
    onSortColumns,
    itemForDelete,
    setItemForDelete,
    onItemDelete,
    filter,
    setFilter,
    showEditAclModal,
    setShowEditAclModal,
    itemForEditing,
    setItemForEditing,
  } = useAclComponent(classes);
  const { access } = useAccess();

  return (
    <div className={classes.wrapper}>
      <Box display="flex" gap={1} alignItems="center" marginBottom={2}>
        <Search fullWidth value={filter} onChange={setFilter} />
        {access?.acl?.canCreate && (
          <AppButton onClick={() => setShowEditAclModal(true)}>
            {t('common.add')}
          </AppButton>
        )}
      </Box>
      <FlexibleColumnsTable
        data={sortedArray}
        columnsList={columnsList}
        order={order}
        orderBy={orderBy}
        onSort={onSort}
        classes={classes}
        onSortColumns={onSortColumns}
        cellReducers={cellReducers}
        onSelectAllRows={() => {}}
        stickyHeader={true}
      />
      <ConfirmDialog
        open={!!itemForDelete}
        onClose={() => setItemForDelete(null)}
        title={t('common.delete')}
        onSubmit={() => onItemDelete()}>
        {t('common.deleteQuestion')}
      </ConfirmDialog>

      <AppDialog
        open={!!showEditAclModal}
        onClose={() => {
          setShowEditAclModal(false);
          setItemForEditing(null);
        }}
        title={
          itemForEditing
            ? t('superAdminDashboard.editPermission')
            : t('superAdminDashboard.addPermission')
        }>
        <AddPermission
          aclItem={itemForEditing}
          onClose={() => {
            setShowEditAclModal(false);
            setItemForEditing(null);
          }}
        />
      </AppDialog>
    </div>
  );
};

export default Permissions;
